// Add videos here, keyed by page path. Example:
// '/services/cooling': { youtubeId: 'abc123XYZ', title: 'How We Repair ACs', description: '...', uploadDate: '2026-06-01', duration: 'PT2M30S' }
export const serviceVideos = {};

export const getYouTubeId = (urlOrId) => {
  const m = String(urlOrId).match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? m[1] : urlOrId;
};

export const getServiceVideo = (path) => {
  const video = serviceVideos[path.replace(/\/$/, '')];
  if (!video) return null;
  const id = getYouTubeId(video.youtubeId);
  return {
    ...video,
    id,
    url: `https://www.youtube.com/watch?v=${id}`,
    embedUrl: `https://www.youtube-nocookie.com/embed/${id}`,
    thumbnail: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
  };
};
